import { Component, OnChanges, Input, Output, EventEmitter, inject } from '@angular/core';
import { APIService, portfolioApiDataType } from 'app/services/api.service';
import { AuthenticationService } from 'app/services/auth.service';
import { LoaderService } from "app/services/loader.service";
import { AppConfig } from "app/app.config";
import { SubMenuComponent } from '../sub-menu/sub-menu.component';
import { RouterLink } from '@angular/router';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgClass, DecimalPipe, PercentPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { CYRChartComponent } from '../../NWMCharts/cyrchart.component';
import { ARChartComponent } from '../../NWMCharts/archart.component';
import { AICFChartComponent } from '../../NWMCharts/aicfchart.component';
import { CFCYChartComponent } from '../../NWMCharts/cfcychart.component';
import { PortfolioAllocationComponent } from '../../NWMCharts/PortfolioAllocation.component';
import { PortfolioAssetsComponent } from './portfolio-assets.component';
import { PortfolioTransactionsComponent } from './portfolio-transactions.component';
import { MinusSignToParens } from 'app/pipes/minus-sign-to-parens.pipe';

type planType = {
  id: string;
  Currency: string;
  PlanName?: string;
  title: string;
  TargetNameID1?: number;
  TargetNameID2?: number;
  AccountNumber?: number;
};

@Component({
    selector: 'portfolio-details',
    templateUrl: 'portfolio-details.component.html',
    styleUrls: ['portfolio-details.component.scss'],
    imports: [SubMenuComponent, RouterLink, NgbTooltip, NgClass, CYRChartComponent, ARChartComponent, AICFChartComponent, CFCYChartComponent, PortfolioAllocationComponent, PortfolioAssetsComponent, PortfolioTransactionsComponent, MinusSignToParens, DecimalPipe, PercentPipe, CurrencyPipe, DatePipe]
})

export class PortfolioDetailsComponent implements OnChanges {
  private api = inject(APIService);
  private auth = inject(AuthenticationService);
  private loaderService = inject(LoaderService);
  private config = inject(AppConfig);

  @Input() plan?: planType;
  @Output() pdChange : EventEmitter<portfolioApiDataType>;

  public portfolio?: portfolioApiDataType;
  public valuationDate = '';
  public CYRChart_loaded = false;
  public AICFChart_loaded = false;
  public CFCYChart_loaded = false;

  public plan_prefix = '';
  public plan_postfix = '';
  public daysSinceInception: null | number = null;
  public isPershing = false;
  public account = '';

  public inceptionDate?: string;

  public subMenuItems = [
    {key :'summary', title: 'Summary'},
    {key :'returns', title: 'Performance'},
    {key :'asset',   title: 'Asset Allocation'},
  ];

  constructor() {
    this.pdChange = new EventEmitter<portfolioApiDataType>();
  }

  ngOnChanges(): void {
    this.daysSinceInception = null;
    this.inceptionDate = undefined;

    this.loaderService.display(true, 'PortfolioDetails');
    const reRg = this.auth.getCurrentReRg()!;
    this.isPershing = reRg.IsPershing;
    this.valuationDate = this.auth.getCurrentValuationDate();
    const planPath = this.api.getPlanPath(this.plan?.id || '', reRg.IsPershing);

    this.api.get<portfolioApiDataType>(`${this.config.portfolio.portfolioSummaryUrl}/${reRg.ReRgId}/${this.valuationDate}/${planPath}`).subscribe(
      data => {
        this.portfolio = data;
        this.pdChange.emit(data);

        if (this.plan) {
          this.plan_prefix = (this.plan.id === 'CAD' ? 'Canadian ' : this.plan.id === 'USD' ? 'US ' : '');
          this.plan_postfix = (this.plan.id !== 'CAD' && this.plan.id !== 'USD' && this.plan.Currency === 'USD' ? ' (USD)' : '');
        } else {
          this.plan_prefix = '';
          this.plan_postfix = '';
        }

        this.inceptionDate = this.portfolio.inceptionDate;
        const d1 = this.valuationDate.toNWMdate();
        const d2 = this.portfolio.inceptionDate.toNWMdate();
        this.daysSinceInception = (+d1 - +d2) / 1000 / 60 / 60 / 24;
        if (this.plan && this.plan.title) {
          this.account = this.plan.title.substring(0, this.plan.title.indexOf(' - '));
        }

        if (this.account != 'Overview' && this.account != '') {
          this.subMenuItems = [
            {key :'summary', title: 'Summary'},
            {key :'returns', title: 'Performance'},
            {key :'asset',   title: 'Asset Allocation'},
            {key :'investments',   title: 'Investment Summary'},
            {key :'transactions',   title: 'Transactions'},
            ];
        } else {
          this.subMenuItems = [
            {key :'summary', title: 'Summary'},
            {key :'returns', title: 'Performance'},
            {key :'asset',   title: 'Asset Allocation'},
          ];
        }

        this.loaderService.display(false, 'PortfolioDetails');
      },
      () => {
        this.loaderService.display(false, 'PortfolioDetails');
      }
    );
  }

}